<template>
  <div class="home">
    <h1>Latest Lesson</h1>
    <LessonVideo
      :videoSource="getMostRecent().videoName"
      :notes="getMostRecent().notes"
    />
  </div>
</template>

<script>
import LessonVideo from '@/components/LessonVideo.vue'
import videos from '../videos'

export default {
  name: 'Home',
  components: {
    LessonVideo
  },
  computed: {
    lessonVideos() {
      return videos
    }
  },
  methods: {
    getMostRecent() {
      return this.lessonVideos[0]
    }
  }
}
</script>
